import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-grip-vertical text-secondary" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "badge badge-secondary ml-2"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["for"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Renommer ")
const _hoisted_7 = { class: "badge badge-dark" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("legend", { class: "h6" }, "Options", -1)
const _hoisted_10 = { class: "form-group col" }
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" choix unique ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("small", { class: "small text-muted" }, "(ex: \"Aucun\")", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Annuler ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Confirmer ")

import { computed, ref, onMounted } from "vue";
import axios from "@/api";
import ActionDialog, { type ActionProps } from "./ActionDialog.vue";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { useAlert } from "@/composables/alert";
import FormCheck from "./FormCheck.vue";
import type { Choice, ChoicePayload } from "@/types/index.js";

interface ChoiceUpdateProps extends ActionProps {
    initialState: Choice;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}


export default /*#__PURE__*/_defineComponent({
  props: {
    initialState: null,
    campaignId: null
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update', value: typeof edit.value): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    initialState: Choice;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}



const alert = useAlert();

const edit = ref<ChoicePayload>({
    name: '',
    isNone: false,
});

const isOpen = ref(false);
const isLoading = ref(false);

const isDisabled = computed<boolean>(() => {
    return '' === edit.value.name.trim() || (
        edit.value.name.trim() === props.initialState.name.trim()
        &&
        edit.value.isNone === props.initialState.isNone
    );
});



function reset() {    
    edit.value.name = props.initialState.name;
    edit.value.isNone = props.initialState.isNone;
    alert.value = null;
}

onMounted(() => {
    reset();
});

function updateChoice(): void {
    const payload: ChoicePayload = {
        name: edit.value.name,
        isNone: edit.value.isNone,
    };

    isLoading.value = true;
    
    axios
        .put(`/choices/${props.initialState.id}`, payload)
        .then(() => {
            emit('update', edit.value);

            alert.value = {
                status: 'success',
                summary: 'Le choix a été mis à jour avec succès',
            };
        })
        .catch(({ response }) => {
            alert.value = {
                status: (409 === response.status) ? 'conflict' : 'error',
                detail: (409 === response.status) ? response.data['hydra:description'] : undefined
            };
        })
        .finally(() => {
            isLoading.value = false;
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(updateChoice, ["prevent"]),
    class: "d-flex align-items-center col-9 col-md-11 p-2"
  }, [
    _hoisted_2,
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true)),
      class: "form-control p-inputtext d-inline-block mx-2 py-0 text-truncate text-left",
      "aria-haspopup": "dialog"
    }, [
      _createElementVNode("span", null, _toDisplayString(__props.initialState.name), 1),
      (__props.initialState.isNone)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " choix unique"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ActionDialog, {
      visible: isOpen.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((isOpen).value = $event)),
      header: "Modifier le choix",
      alert: _unref(alert),
      "campaign-id": props.campaignId,
      onHide: reset
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          class: "p-button-text",
          onClick: _cache[3] || (_cache[3] = ($event: any) => {isOpen.value = false;})
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          type: "submit",
          disabled: _unref(isDisabled),
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            for: `choice-${__props.initialState.id}-label`,
            class: "d-block"
          }, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.initialState.name), 1),
            _hoisted_8
          ], 8, _hoisted_5),
          _createVNode(_unref(InputText), {
            modelValue: edit.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((edit.value.name) = $event)),
            id: `choice-${__props.initialState.id}-label`,
            placeholder: __props.initialState.name,
            class: "form-control",
            autocomplete: "off",
            required: "",
            maxlength: "45"
          }, null, 8, ["modelValue", "id", "placeholder"])
        ]),
        _createElementVNode("fieldset", null, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(FormCheck, {
                modelValue: edit.value.isNone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((edit.value.isNone) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "alert", "campaign-id"])
  ], 40, _hoisted_1))
}
}

})